import { I as Icon, _ as __assign } from './loadable.esm-c9931684.js';
import React from 'react';
import 'styled-components';

var GuavaIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 60 60" }),
    React.createElement("circle", { cx: 31, cy: 30, r: 28, fill: "#131314" }),
    React.createElement("path", { d: "M31.26 18.29c.07-1.28-.07-3.27-1.28-4.27-.28-.21-.71-.21-.92.07s-.21.71.07.92c.71.64.85 2.13.78 3.27-5.98.36-10.81 6.9-10.81 14.87s5.12 14.94 11.46 14.94 11.46-6.69 11.46-14.94c-.07-7.9-4.77-14.37-10.74-14.87Zm-.71 28.53c-5.62 0-10.17-6.12-10.17-13.66 0-6.69 3.56-12.24 8.25-13.38v.07c0 .28.85.5 1.92.5s1.92-.21 1.92-.5v-.07c4.7 1.21 8.25 6.76 8.25 13.38-.07 7.54-4.62 13.66-10.17 13.66Z", style: {
            fill: "#fff",
        } }))); };

export default GuavaIcon;
